<template>
  <div
    class="fixed bottom-0 z-20 flex w-full items-center justify-center bg-gradient-to-t from-background to-transparent pb-6 pt-4 lg:pb-10"
  >
    <SignUpLink v-if="route.name !== 'Signup'" />
    <SignInLink v-else />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import SignUpLink from '@generics/SignUpLink.vue';
import SignInLink from '@generics/SignInLink.vue';
const route = useRoute();
</script>
